<template>
  <v-app
    data-change-language-button
  >
    <v-btn
      max-width="56"
      min-width="56"
      max-height="32"
      class="change-language-button rounded-xl px-4 py-1"
      :data-qa="`change-language-button-${currentLanguage.iso}`"
      elevation="0"
      color="primary"
      icon
    >
      <v-img
        width="24"
        height="16"
        contain
        alt="language-flag"
        :src="currentLanguage.flagImage.url"
      />
    </v-btn>
    <v-menu
      activator=".change-language-button"
      data-qa="language-menu"
      nudge-bottom="8"
      offset-y
      min-width="260px"
      max-width="260px"
      z-index="9999"
    >
      <div class="p-4">
        <LanguagesList :languages="availableLanguages" />
      </div>
    </v-menu>
  </v-app>
</template>

<script setup lang="ts">
import LanguagesList from 'www/vue_components/common/LanguagesList/LanguagesList.vue'
import { Language } from 'common/types'

const { currentLanguage } = window.LANGUAGE_DATA

defineProps<{
  availableLanguages: Language[],
}>()
</script>

<style lang="scss">
.change-language-button-mount .v-application--wrap {
  min-height: fit-content !important;
}
</style>
